import { render, staticRenderFns } from "./BusinessUnitDetail.vue?vue&type=template&id=1564a677&scoped=true"
import script from "./BusinessUnitDetail.vue?vue&type=script&lang=js"
export * from "./BusinessUnitDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1564a677",
  null
  
)

export default component.exports